module.exports = __webpack_public_path__ + "static/media/sad-azeto.a45eb985.svg";